import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nadou_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response && !error.config?.__retried && typeof window !== "undefined") {
      error.config.__retried = true;
      error.config.baseURL = `${window.location.origin}/api`;
      return api.request(error.config);
    }
    return Promise.reject(error);
  }
);

export const IMAGES = {
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_e4750237-48b5-4ba4-a5b3-1d0ff8fd91b8/artifacts/0ophfvpa_WhatsApp%20Image%202026-08-24%20at%2023.55.07.jpeg",
  salon: "https://customer-assets-eiarnc6j.emergentagent.net/job_e4750237-48b5-4ba4-a5b3-1d0ff8fd91b8/artifacts/wslfs6po_WhatsApp%20Image%202026-08-24%20at%2023.55.07%20%281%29.jpeg",
  laser: "https://customer-assets-eiarnc6j.emergentagent.net/job_e4750237-48b5-4ba4-a5b3-1d0ff8fd91b8/artifacts/6iqfnv10_WhatsApp%20Image%202026-08-24%20at%2023.55.47.jpeg",
  treatment: "https://customer-assets-eiarnc6j.emergentagent.net/job_e4750237-48b5-4ba4-a5b3-1d0ff8fd91b8/artifacts/qdc39vrs_WhatsApp%20Image%202026-08-24%20at%2023.55.47%20%283%29.jpeg",
  machine: "https://customer-assets-eiarnc6j.emergentagent.net/job_e4750237-48b5-4ba4-a5b3-1d0ff8fd91b8/artifacts/wec7zskf_WhatsApp%20Image%202026-08-24%20at%2023.56.00.jpeg",
  regard: "https://images.unsplash.com/photo-1589710751893-f9a6770ad71b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxleWVsYXNoJTIwbGlmdCUyMGJyb3clMjBiZWF1dHl8ZW58MHx8fHwxNzg3NjA5MDg5fDA&ixlib=rb-4.1.0&q=85",
};

export function formatApiError(err, fallback = "Une erreur est survenue") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
